export const getErrorMessage = (e: any, scope: string): string => {
    if (e instanceof Error) {
        return e.message || `${scope}: An unexpected error occurred`;
    } else {
        return `${scope}: An unexpected error occurred`;
    }
};
